import * as React from 'react';
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Select from "react-select";
import {Button, Col, Row, Table} from "react-bootstrap";
import {getProgramme} from "../actions/programmeActions";
import Loader from "../components/Loader";
import Message from "../components/Message";
import {logout} from "../actions/userActions";
import {listVideoPlayers} from "../actions/videoPlayerActions";
import {getVideoProgramme} from "../actions/videoProgrammeActions";

const VideoProgrammesScreen = ({history, language, t}) => {

    const dispatch = useDispatch();
    const userLogin = useSelector((state) => state.userLogin);
    const {userInfo} = userLogin;
    const videoPlayersList = useSelector((state) => state.videoPlayerList);
    const { videoPlayers, error} = videoPlayersList;
    const programmeList = useSelector((state) => state.videoProgrammeList);
    const { loading: programmeLoading, programme, error: programmeError} = programmeList;
    const [playerOptions, setPlayerOptions] = useState([]);
    const [selectedPlayer, setSelectedPlayer] = useState();
    const [programmeDate, setProgrammeDate] = useState(new Date().toISOString().split('T')[0]);
    const [videos, setVideos] = useState([]);
    const [videoVideoCampaigns, setVideoCampaigns] = useState([]);

    useEffect(() => {
        if (!userInfo) {
            history.push('/login');
        }
    }, [history, userInfo]);

    useEffect(()=>{
        if(error && error.includes('Not authorized')){
            dispatch(logout());
            history.push('/login');
        }
    },[error]);

    useEffect(()=>{
        setVideos([]);
        setVideoCampaigns([]);
        dispatch(listVideoPlayers());
    },[dispatch]);

    useEffect(()=>{
        if (videoPlayers) {
            setVideos([]);
            setVideoCampaigns([]);
            const moddedList = videoPlayers.map((element) => {
                element.label = element.name;
                element.value = element._id;
                return element;
            });
            setPlayerOptions(moddedList);
        }
    },[videoPlayers]);

    useEffect(()=>{
        if(programme){
            //console.log(programme);
            setVideos(programme.videos);
            //console.log(programme.videos);
            setVideoCampaigns(programme.videoCampaigns);
        }
    },[programme]);

    const onSelectedPlayersChange = (playerFromSelect) => {
        setSelectedPlayer(playerFromSelect);
    };

    return (
        <>
            <h1>
                {t('programmes_title')}
            </h1>
            <Row className='align-items-center mt-4'>
                <Col md={8}>
                    <Select
                        options={playerOptions}
                        name='Players'
                        isClearable
                        isSearchable
                        onChange={onSelectedPlayersChange}
                        className='react-select-container'
                        classNamePrefix='react-select'
                        placeholder={t('programmes_player_description')}
                    />
                </Col>
                <Col md={2}>
                    <input
                        type='date'
                        onChange={(e) => {
                            setProgrammeDate(e.target.value);
                        }}
                        value={programmeDate}
                    />
                </Col>
                <Col md={2}>
                    <Button size='md' variant='info' onClick={() => {
                        if(selectedPlayer) {
                            dispatch(getVideoProgramme(selectedPlayer.folder, programmeDate.replaceAll('-', '.')));
                        }
                    }}>{t('button_display')}</Button>
                </Col>
            </Row>
            {programmeLoading ? (<Loader />) : (programmeError ? (<Message variant='danger'>{programmeError}</Message>) : (
                <div className='mt-5'>

                    {(videoVideoCampaigns && videoVideoCampaigns.length !== 0) ? (
                        <div>
                            <h3>{t('video_campaigns')}</h3>
                            <Table size={'sm'}>
                                <thead>
                                <tr>
                                    <th className={'col-md-6'}>
                                        {t('programmes_name')}
                                    </th>
                                    <th className={'col-md-6'}>
                                        {t('programmes_period')}
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                {videoVideoCampaigns.map(campaign => {
                                    return (
                                        <tr>
                                            <td>
                                                {campaign.name}
                                            </td>
                                            <td>
                                                {campaign.from} - {campaign.to}
                                            </td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </Table>
                        </div>
                    ) : (<div></div>)}

                    {(videos && videos.length !== 0) ? (<div>
                        <h3>{t('programmes_schedule')}</h3>
                        <Table size={'sm'}>
                            <thead>
                            <tr>
                                <th className={'col-md-6'}>
                                    {t('programmes_files')}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {videos?.map(video => <tr>
                                <td>
                                    {video.name}
                                </td>
                            </tr>)}
                            </tbody>
                        </Table>
                    </div>) : (<div></div>)}

                </div>
            ))}
        </>
    );
};

export default VideoProgrammesScreen;
